import get from 'lodash/get';
import { request } from 'lib';
import { UiToast, UiModal } from 'components';
import { getGlobalStore, globalStore } from 'stores';
import { getStore } from '../store';

// 接口文档
// https://mock.memeyule.com/project/16/interface/api/23368

const loadInfo = () => {
  const {
    room: { roomInfo, roomId },
    lianmai: { heartbeatPk },
  } = getStore();
  request.cryolite
    .get('/api/v1/punishpk/info', {
      room_id: roomId,
    })
    .then((res) => {
      const { mode_info } = res.data;
      // 按照 live_streams 顺序排序
      if (roomInfo.isHeartbeatPk && mode_info && mode_info.multi_pk_info) {
        mode_info.multi_pk_info = roomInfo.live_streams.map((item) => {
          return mode_info.multi_pk_info.find((item2) => {
            return item2.room_id === item.uid;
          });
        });
      }

      heartbeatPk.updateInfo(res.data);
    });
};

// 关播时退出
const liveOffExit = () => {
  const info = get(getStore(), 'lianmai.heartbeatPk.info') || {};

  if (info.isMatching) {
    cancelMatch();
  }
  if (info.isInPk) {
    UiToast.fail('正在心跳PK中，请先退出');
    throw new Error('正在心跳PK中，请先退出');
  }
};

const joinMatch = () => {
  request.cryolite
    .post('/api/v1/punishpk/match', null, {
      event: 'heartbeatPK',
      event_type: 'joinMatch',
      desc: '发起匹配',
    })
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已发起匹配');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

const cancelMatch = (matchingId) => {
  request.cryolite
    .post(
      '/api/v1/punishpk/match/cancel',
      {
        matchingId,
      },
      {
        event: 'heartbeatPK',
        event_type: 'cancelMatch',
        desc: '取消匹配',
      },
    )
    .then((res) => {
      reload();
      UiToast.success(res.msg || '已取消匹配');
    })
    .catch((res) => {
      reload();
      UiToast.fail(res.msg || '操作异常');
    });
};

const reload = () => {
  loadInfo();
};

const loadPunishList = () => {
  return request.cryolite.get('/api/v1/punishpk/contents');
};

const setPunishContent = (content) => {
  request.cryolite
    .post('/api/v1/punishpk/set_content', { content })
    .then((res) => {
      // reload();
      UiToast.success('已设置惩罚内容');
    })
    .catch((res) => {
      UiToast.fail(res.msg || '操作异常');
    });
};

export default {
  loadInfo,
  liveOffExit,
  joinMatch,
  cancelMatch,
  reload,
  loadPunishList,
  setPunishContent,
};
